import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "visually-hidden" }
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "active-notification" }, null, -1)

import { computed } from 'vue';
    import { useStore } from 'vuex';
    import { useRouter } from 'vue-router';
    import { useI18next } from '@composables/i18next';
    import ActivityIcon from './icons/ActivityIcon.vue';
    import AwardsIcon from './icons/AwardsIcon.vue';
    import SkillsIcon from './icons/SkillsIcon.vue';
    import PrizesIcon from './icons/PrizesIcon.vue';

    
export default {
  __name: 'FloatingNavigation',
  setup(__props) {

    const route = useRouter();

    const store = useStore();

    const { t, vT } = useI18next('floating_navigation');

    const currentRoute = computed(() => route.currentRoute.value.fullPath);

    const icons = [
        {
            id: 'instantWin',
            component: AwardsIcon,
            to: '/bubble-pop',
        },
        {
            id: 'activities',
            component: ActivityIcon,
            to: '/activities',
        },
        {
            id: 'skillGame',
            component: SkillsIcon,
            to: '/summer-worlds',
        },
        {
            id: 'prizes',
            component: PrizesIcon,
            to: '/prizes',
        },
    ];

    const hasPendingNotification = computed(() =>
        (routeId) => {
            let hasNotification = false;
            switch (routeId) {
                case 'activities':
                    hasNotification = store?.getters['challenges/sortedChallengeIds']?.claimable?.length;
                    break;
                case 'instantWin':
                    hasNotification = store?.state?.profile?.plays_remaining > 0;
                    break;
                default:
                    break;
            }
            return hasNotification;
        });

    const isRouteActive = computed(() =>
        (route) => {
            let isActive = false;
            switch (route.id) {
                case 'skillGame':
                    isActive = currentRoute.value.startsWith('/summer-worlds');
                    break;
                default:
                    isActive = currentRoute.value.startsWith(route.to);
            }
            return isActive;
        });

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("nav", {
    class: "floating-navigation",
    "aria-label": _unref(t)('navigationAriaLabel')
  }, [
    _createElementVNode("ul", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(icons, (icon) => {
        return _createElementVNode("li", {
          key: `icon-${icon.id}`,
          class: _normalizeClass({ active: isRouteActive.value(icon) })
        }, [
          _createVNode(_component_router_link, {
            to: icon.to
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("span", _hoisted_2, null, 512), [
                [_unref(vT), `${icon.id}.ariaLabel`]
              ]),
              (hasPendingNotification.value(icon.id))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "notification",
                    title: _unref(t)(`${icon.id}.notification`)
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true),
              (_openBlock(), _createBlock(_resolveDynamicComponent(icon.component))),
              _hoisted_4
            ]),
            _: 2
          }, 1032, ["to"])
        ], 2)
      }), 64))
    ])
  ], 8, _hoisted_1))
}
}

}